module.exports = __webpack_public_path__ + "static/media/btn.cb36f31c.png";